<template>
    <div>
        <b-container>
          <b-button :to="{ name: 'Home'}"  variant="primary" class="mb-2">Voltar</b-button>
          <b-form inline>
            <b-form-datepicker
            id="dtinicio"
            placeholder="data inicio"
            class="mb-2 mr-sm-2 mb-sm-0"
            v-model="dtinicio"
            ></b-form-datepicker>

            <b-form-datepicker
            id="dtfim"
            placeholder="data fim"
            class="mb-2 mr-sm-2 mb-sm-0"
            v-model="dtfim"
            ></b-form-datepicker>

            <b-button @click="pesquisa()"  class="mt-2" variant="primary" block >Pesquisa</b-button>
          </b-form>
          <b-tabs class="mt-3">
          <b-tab title="Quantidade">
            <b-col md="12 mr-2 mb-2 mt-2">
              <Grafico :height='200' :data="chartData" :options="options" :key="componentKey"/>
            </b-col>
          </b-tab>
          <b-tab title="Valor" @click="componentKeyVlr++">
            <b-col md="12 mr-2 mb-2 mt-2">
              <Grafico :height='200' :data="chartDataVlr" :options="optionsVlr" :key="componentKeyVlr"/>
            </b-col>
          </b-tab>
         </b-tabs>
          <b-card border-variant="primary" header="Produção" header-bg-variant="primary" header-text-variant="white">
            <b-table-simple class='table table-sm'>
              <b-thead>
                <b-tr >
                  <b-th>
                    Descrição
                  </b-th>
                  <b-th>
                    Qtd.
                  </b-th>
                  <b-th :style = "{'textAlign': 'right'}">
                    Valor
                  </b-th>
                </b-tr>
               </b-thead>
                <b-tbody>
                    <b-tr v-for="(item, index) in listafinanceiro" :key="index" :style="'color:#'+item.cz46_cor+';margin-top:1px;margin-bottom:1px;font-size:0.8em'">
                      <b-td >
                        <b-badge :style="{backgroundColor: '#' + item.cor}">&nbsp;</b-badge>
                        <span>
                         {{item.cz02_nome}}
                        </span>
                      </b-td>
                      <b-td >
                         {{item.qtbolt}}
                      </b-td>
                      <b-td :style = "{'textAlign': 'right'}">
                         {{item.valortotal}}
                      </b-td>
                    </b-tr>
                 </b-tbody>
            </b-table-simple>
          </b-card>
        </b-container>
    </div>
</template>

<script>
import ListaFinanceiroService from '../services/ListaFinanceiroService'
import Grafico from '../components/Grafico'
import moment from 'moment'

export default {
  name: 'listafinanceiro',
  components: { Grafico },
  data () {
    return {
      usuario: {},
      listafinanceiro: [],
      componentKey: 0,
      componentKeyVlr: 0,
      dtinicio: moment().format(),
      dtfim: moment().format(),
      options: {
        responsive: true,
        height: '200',
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'bottom'
        },
        title: {
          display: true,
          text: 'Qtd. Atendimentos'
        }
      },
      optionsVlr: {
        responsive: true,
        height: '200',
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        title: {
          display: true,
          text: 'Valor Atendimentos'
        }
      },
      chartData: {
        labels: [],
        datasets: [
          {
            backgroundColor: []
            // data: [1, 2]
          }
        ]
      },
      chartDataVlr: {
        labels: [],
        datasets: [
          {
            backgroundColor: []
            // data: [1, 2]
          }
        ]
      }
    }
  },
  created () {
    const usuario = JSON.parse(localStorage.usuarioMC).usuario
    this.usuario = usuario
    this.pesquisa()
  },
  methods: {
    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    pesquisa () {
      const obj = JSON.parse(localStorage.usuarioMC)
      const pesquisa = {
        empresa: JSON.stringify(obj.empresa),
        datafim: moment(this.dtfim).format(),
        datainicio: moment(this.dtinicio).format(),
        grafico: 'true',
        grupousu: this.usuario.cz10_grupo,
        nomepaciente: '',
        pendentes: 'true',
        socioadm: 'N',
        tipopesquisasocioadm: 'false'
      }
      if (this.usuario.cz08_crem !== undefined) {
        pesquisa.crm = this.usuario.cz08_crem
      }

      ListaFinanceiroService.index(pesquisa).then((result) => {
        for (let element of result) {
          let randomColor = Math.floor(Math.random() * 16777215).toString(16)
          this.chartData.labels.push(element.cz02_nome)
          this.chartData.datasets[0].data.push(element.qtbolt)
          this.chartData.datasets[0].backgroundColor.push('#' + randomColor)

          this.chartDataVlr.labels.push(element.cz02_nome)
          this.chartDataVlr.datasets[0].data.push(element.valortotal)
          this.chartDataVlr.datasets[0].backgroundColor.push('#' + randomColor)

          element.cor = randomColor
          element.valortotal = this.formatPrice(element.valortotal)
        }
        this.componentKey += 1
        this.componentKeyVlr += 1
        this.listafinanceiro = result
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/Listafinanceiro.vue